import { AnalyticsEvents } from '../../common/config/api';
import tabbable from 'tabbable';
import enums from '../../common/config/enums';
// Internal

/**
 * Calls group validation on all composite fields
 * @todo pass in fieldGroups rather than getting them from context
 * @returns {boolean}
 */
function validateAllGroups() {
  var groupValid = true,
    i = 0,
    a,
    len = NGX.entryForm.fieldGroups.length;
  for (; i < len; i++) {
    a = NGX.entryForm.fieldGroups[i].call(NGX.entryForm.fieldGroups[i], 'force');
    if (!a) groupValid = false;
  }
  return groupValid;
}

// Public

/**
 * Build/populate hidden fields
 * @param targ      target element
 * @param response  the FB response containing values to be used
 * @param {boolean} submitOnDone
 * @return {Array|boolean}  An array of fields updated/created
 */

export function populateFormData(targ, response, submitOnDone) {
  // no point running this without a target, drop out early
  if (!targ) return false;

  var d = document,
    // array of modified fields to return
    updated = [],
    // add a hidden field to the form
    add = function(id, val) {
      var el = d.createElement('input');
      el.setAttribute('type', 'hidden');
      el.setAttribute('name', id);
      el.setAttribute('value', val || '');
      el.id = id;
      targ.appendChild(el);
      return el;
    },
    // update field value, create if it does not exist
    check = function(id, val) {
      var field = d.getElementById(id);
      if (field) {
        if (field.value === val) return false;
        else field.setAttribute('value', val || '');
      } else field = add(id, val);
      updated.push(field);
    },
    user = NGX.App.state.currentUser.userSession;

  if (response) {
    // pre-defined fields to populate from FB response;
    check('fbname', response.name);
    check('fbid', response.id);
    check('fblink', response.link);
    check('fblocale', response.locale);
    check('fbfirstname', response.first_name);
    check('fblastname', response.last_name);
    if (user && user.authResponse) check('fboauth_token', user.authResponse.accessToken);
  }
  if (submitOnDone === true) targ.submit();
  else return updated;
}

/**
 * Validates email address
 * @param {string} elementValue : Email address
 * @returns {boolean}
 */
export function validateEmail(elementValue) {
  var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/;
  return emailPattern.test(elementValue);
}

/**
 * Resizes a paged form's wrapper to the size of the visible page
 * @param {Dom element | jQuery Dom object} $form - the form containing the pages
 */
export function formWrapperResize($form) {
  var totalOuterHeight = 0;

  $('.xFormPage.cycle-slide-active, .xFormPage:visible', $form).each(function() {
    totalOuterHeight += $(this).outerHeight(true);
  });

  $('.xFormPages:not(.xTransitioning)', $form).animate(
    {
      height: totalOuterHeight,
    },
    'fast',
    function() {
      NGX.App.Events.trigger('form:resize:complete');
      NGX.App.api.resizeParent();
    }
  );
}

/**
 * If entry is a state, route to it - otherwise submit the hidden form
 * @param displayState
 * @returns {*}
 */

export function submit(displayState) {
  return NGX.App.api.campaignEntry(displayState);
}

/**
 * Element type checks
 * DEPRECATED - don't seem to be in use
 * @param {Dom element} el
 * @returns {boolean}
 */

export function isCheckbox(el) {
  return el.getAttribute('type') === 'checkbox';
}

export function isSelectbox(el) {
  return typeof el.selectedIndex !== 'null';
}

/**
 * Generate a random number between 1 and [max] (defaults to 1-9999)
 * @param {number} max
 * @returns {integer}
 */

export function random(max) {
  var type = typeof max,
    maxInt = 'undefined' !== type && 'number' !== type ? parseInt(max, 10) : max;
  return Math.floor(Math.random() * (maxInt + 1 || 9999));
}

/**
 * Get the params of the captcha lib (depends of the strategy we use)
 * @param {*} strategy Fraud detection strategy
 * @returns {Object} The captcha params (see coreapp/src/main/javascript/display/common/config/enums.js, CAPTCHA_LIBS)
 */
export function getCaptchaParams(strategy) {
  switch (strategy) {
    case enums.STRATEGY_FRAUD_CAPTCHA:
    case enums.STRATEGY_FRAUD_DYNCAPTCHA:
      return enums.CAPTCHA_LIBS.recaptcha;
    case enums.STRATEGY_FRAUD_TURNSTILE:
    case enums.STRATEGY_FRAUD_DYNCAPTCHA_TURNSTILE:
      return enums.CAPTCHA_LIBS.turnstile;
  }
}

/**
 * Verify the person voting is a human by requesting they completing a captcha before their vote is submitted
 * @param callback : {Function} method to call on success
 * @param captchaLib : {string} The name of the captcha library which we will use in client side
 * @param captchaSdk : {string} The name of SDK for the captcha library
 * @param isForm : {boolean} Are we in the form?
 */

export function verifyHuman(callback, captchaLib, captchaSdk, isForm = false) {
  if (captchaSdk && captchaLib) {
    NGX.Util.requireSDK(captchaSdk, function() {
      // 1. Show overlay
      NGX.overlay.create({
        content:  NGX.App.api.getTemplate('recaptcha'),
        type:     'modal captcha',
        callback: function() {
          // 2. Instantiate Recaptcha
          var _self = this;
          var _cb = function(response) {
            _self.$el.fadeOut('slow', function() {
              callback.call(this, response);
              _self.destroy();
            });
          };
          window[captchaLib].render(document.getElementById('recaptchaWrapper'), {
            sitekey:  NGX.App.config[`${captchaLib}SiteKey`],
            theme:    'light',
            callback: _cb,
            action: captchaLib ==='turnstile'?`${NGX.App.config.turnstileActionPrefix}_${NGX.App.config.tenant}_${NGX.App.config.id}`:null,
          });
        },
        onclose: function() {
          if (isForm) {
            $('.xSubmit').attr('disabled', null);
          }
        },
      });
    });
  }
}

/**
 * Validates a given form using Parsley + group validation
 * @param {Dom element|string} [form] : an actual form element or a dom ID
 * @returns {boolean}
 */

export function validate(form) {
  const $form = $(form || '#xCampaignForm');

  NGX.App.Events.trigger('form:validate');
  // if there is no form allow validation to pass.
  if ('undefined' === typeof $form || $form.length === 0) return true;

  // do the validation
  var parsleyFieldsValid = $form.parsley('validate');
  var groupsValid = validateAllGroups();
  var valid = parsleyFieldsValid && groupsValid;

  // return validation state regardless of callback behaviour
  if (typeof valid === 'boolean') {
    formWrapperResize($form);

    NGX.App.Events.trigger('form:validation:' + (valid ? 'passed' : 'failed'));
    if (!valid) {
      const _firstError = $('.xFieldError')[0];
      if (_firstError) {
        // Focus the first field with an error.
        $('input:first, textarea:first', _firstError).focus();

        // Get the local window offset.
        const buffer = 50;
        let y = $(_firstError).offset().top - buffer;

        // If we are framed, retreive and add the current parent window offset before scrolling.
        if (NGX.App.state.framed && NGX.App.state.useApi && !NGX.context.isFB) {
          NGX.App.api.messageParent({ action: 'getpageinfo' }, function(info) {
            y += info.offsetTop;
            NGX.App.api.scrollTo(0, y);
          });

          // If we are not framed, just scroll.
        } else {
          NGX.App.api.scrollTo(0, y);
        }
      }
    }
    return valid;
  }

  // if the return value was not true/false something went badly wrong
  throw new Error('NGX Error: form validation did not return a boolean');
}

/**
 * Removes UIFlow listeners from forms
 */
export function removeFormListeners() {
  'use strict';
  log.debug('Destroying form listeners', 6);
  try {
    NGX.App.Events.off('flow:next:xCampaignForm flow:prev:xCampaignForm flow:after:xCampaignForm');
    const _flow = NGX.uiFlow.get('xCampaignForm');
    _flow.$form.parsley('destroy');
    _flow.$form.off();
    _flow.destroy();
  } catch (err) {
    log.debug('Error destroying form bindings; Element possibly already destroyed?', 1);
  }
}

/**
 * Register a custom validation function
 * @param {string} id
 * @param {Function} fn
 * @returns {boolean}
 */
export function addCustomValidation(id, fn) {
  if (id && 'function' === typeof fn) {
    NGX.entryForm.customValidations[id] = fn;
    return true;
  }
  return false;
}

/**
 * Register a custom validation function for composite fields
 * @deprecated
 * @param {string} id
 * @param {Function} fn
 * @returns {boolean}
 */
export function addCompositeCustomValidation(id, fn) {
  if (id && 'function' === typeof fn) {
    NGX.entryForm.compositeCustomValidations[id] = fn;
    return true;
  }
  return false;
}

/**
 * Creates a random UID for file uploader
 * @param {boolean} rndCase (include upper and lower case?)
 * @returns {string}
 */
export function createNgxUUID(rndCase) {
  var uv = '89ab';
  var rndS = '',
    i,
    c;
  for (i = 0; i < 32; i++) {
    c = ((Math.random() * 16) | 0).toString(16);
    if (rndCase && rndCase == true && Math.round(Math.random()) == 1) {
      c = c.toUpperCase();
    }
    rndS += c;
  }
  return [
    rndS.substr(0, 8),
    rndS.substr(8, 4),
    '4' + rndS.substr(12, 3),
    uv.charAt((Math.random() * 4) | 0) + rndS.substr(16, 3),
    rndS.substr(20, 12),
  ].join('-');
}

/**
 * On country selection, update the state field's value
 * @param {Dom element|string} el -jQueryable element reference or element
 */
export function countryCheck(el) {
  var $el = $(el),
    $fieldWrap = $el.parents('.xFieldItem');

  $el.attr('data-ngx-touched', 'true');

  if ($fieldWrap.hasClass('xFormatAddressUs')) {
    var $stateControl = $('[name="' + $fieldWrap.attr('data-ngx-control') + '_State"]', $fieldWrap),
      setStateVal = function(val) {
        // Field is not always a selectize field (mobile)
        if ($stateControl.hasClass('selectized')) {
          $stateControl = $stateControl.selectize()[0].selectize;
          $stateControl.setValue(val);
        } else {
          $stateControl.val(val);
        }
      };

    // Auto select "Other" in state list
    if ($el.val() !== 'USA') {
      setStateVal('OTHER');
    } else {
      if ($stateControl.val() == 'OTHER') setStateVal('');
    }
  } else {
    // NGX-4216 : Why are we revalidating the whole form on non-US address country change?
    // $el.parents('form').parsley('validate');
  }
}

/**
 * Similar to _.findWhere?
 * @param {Array} dataArray
 * @param {string} fieldName
 * @param {string} fieldValue
 * @returns {Array}
 */

export function getItemsByFieldValue(dataArray, fieldName, fieldValue) {
  var ret = [];
  var currentValue;
  for (i = 0; i < dataArray.length; i++) {
    currentValue = fieldName ? dataArray[i][fieldName] : dataArray[i];
    if (currentValue == fieldValue) {
      ret.push(dataArray[i]);
    }
  }
  return ret;
}

/**
 * Switch marketing fields from Opt In to Opt Out - never liked this
 * @param {Dom element} control
 * @param {string} name
 */
export function changeMarketing(control, name) {
  var obj = document.getElementById(name);
  if (control.checked) {
    obj.value = '';
  } else {
    obj.value = control.value;
  }
}

/**
 * Disable file upload fields (for unsupported browsers)
 */
export function disableUpload() {
  // Prevent default click event handling.
  $('input[type=file]').click(function(e) {
    e.preventDefault();
  });

  // Output error message.
  var msg =
    NGX.lang.get('form.uploadUnsupported') ||
    'Uploading files is not supported by your device or the current browser in use.  This can sometimes be caused by browsing inside applications such as Facebook. Please try again on a desktop/laptop to avoid this issue.';
  $('.xControlUpload .xFieldContainer').prepend('<div class="xErrorLabel xUploadUnsupported">' + msg + '</div>');

  // Hide field and help text (but dont set display:none property, as this will stop validation from working on the field).
  $('.xControlUpload .xField, .xControlUpload .xHelpContainer').css({ opacity: 0, height: '0px' });

  // Set field container to error style.
  $('.xControlUpload .xFieldContainer').addClass('xFieldError');
}

/**
 * Restricts input on fields (useful for number fields etc)
 * @param {Dom element} field
 * @param {Regex} restrictRegExp
 * @param {number} maxLength
 */
export function restrictInput(field, restrictRegExp, maxLength) {
  // restrict field input

  field.keypress(function(event) {
    // Allow: backspace, delete, tab, escape, and enter
    var character = String.fromCharCode(event.which);
    if (
      event.which == 0 ||
      /*event.which == 46 ||*/ event.which == 8 ||
      event.which == 9 ||
      event.which == 27 ||
      event.which == 13 ||
      event.which == 127 ||
      // Allow: Ctrl+A
      (event.which == 65 && event.ctrlKey === true) ||
      (event.which == 97 && event.ctrlKey === true) ||
      //Allow: Ctrl+V
      (event.which == 87 && event.ctrlKey === true) ||
      (event.which == 118 && event.ctrlKey === true) ||
      //Allow: Ctrl+C
      (event.which == 67 && event.ctrlKey === true) ||
      (event.which == 99 && event.ctrlKey === true) ||
      // Allow: home, end, left, right
      (event.keyCode >= 35 && event.keyCode <= 39 && event.charCode != undefined && event.keyCode != event.charCode)
    ) {
      // let it happen, don't do anything
      return this;
    } else {
      // check if the key is allowed or not
      if (!character.match(restrictRegExp)) {
        event.preventDefault();
      }
    }

    field.keyup(function(event) {
      var fieldVal = field.val();
      if (!isNaN(maxLength) && fieldVal.length > maxLength) {
        field.val(fieldVal.substr(0, maxLength));
      }
    });
  });
}

// IE11: requires a polyfill for matches
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

/**
 * Finds the first parent of an element that matches a selector string
 * @param {Element} elem
 * @param {string} selectorString
 * @return {Element|undefined}
 */
export function findParent(elem, selectorString) {
  var current = elem;
  while (current !== document.body) {
    current = current.parentElement;
    if (current.matches(selectorString)) {
      return current;
    }
  }
  return;
}

/**
 * Keeps focus within an element
 * @param {Element} el
 */
export function keyboardTrap(el) {
  var focusableElements = tabbable(el, { includeContainer: true });
  var first = focusableElements[0];
  var last = focusableElements[focusableElements.length - 1];
  if (first && last) {
    first.focus();
    first.addEventListener('keydown', function(e) {
      if (e.shiftKey && e.keyCode === 9 && e.target === first) {
        e.preventDefault();
        last.focus();
      }
    });
    last.addEventListener('keydown', function(e) {
      if (!e.shiftKey && e.keyCode === 9 && e.target === last) {
        e.preventDefault();
        first.focus();
      }
    });
  } else {
    // Please update message if this function is used outside of Overlay.
    console.warn('Necessary markup is not present in Overlay to create a keyboard trap.');
  }
}
